import { render, staticRenderFns } from "./nutrition-package.vue?vue&type=template&id=6a7adb98&"
import script from "./nutrition-package.vue?vue&type=script&lang=js&"
export * from "./nutrition-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports